export default "__VITE_ASSET__0565e6f5__"